module.exports = __webpack_public_path__ + "static/media/jaranaBackLittle.82ea95fd.png";